export default {
    
    // Brand and tagline
    "sri_astro_veda": "Surya Media",
    "footer_tagline": "Astrology & Vastu. Modern, Personal, Trusted.",

    // Navigation
    "navigation": "Navigation",
    "home": "Home",
    "about": "About",
    "contact": "Contact", 
    "get_reading": "Get Reading",

    // Core Services
    "core_services_footer": "Core Services",
    "birth_chart_footer": "Birth Chart",
    "match_kundli_footer": "Match Kundli",
    "ascendant_footer": "Ascendant",
    "dasha_analysis_footer": "Dasha Analysis",
    "nakshatra_footer": "Nakshatra",
    "numerology_footer": "Numerology",

    // Predictions
    "predictions_footer": "Predictions",
    "life_predictions_footer": "Life Predictions",
    "2025_report_footer": "2025 Report",
    "daily_horoscope_footer": "Daily Horoscope",
    "love_report_footer": "Love Report",
    "career_report_footer": "Career Report",
    "health_report_footer": "Health Report",

    // Remedies
    "remedies_footer": "Remedies",
    "lal_kitab_footer": "Lal Kitab",
    "mangal_dosha_footer": "Mangal Dosha",
    "kalsarp_dosh_footer": "Kalsarp Dosh",
    "sade_sati_footer": "Sade Sati",
    "ask_question_footer": "Ask Question",
    "gemstones_footer": "Gemstones",

    // Support
    "support": "Support",
    "whatsapp_support": "WhatsApp Support",
    "available_24_7": "Chat Support",

    // Footer bottom
    "all_rights_reserved": "All rights reserved",
    "made_with": "Made with",
    "in_india": "in India",
    "privacy_policy": "Privacy Policy",
    "terms_of_service": "Terms of Service",
    "disclaimer": "Disclaimer",
    "cancellation_policy": "Cancellation Policy",
    "shipping_policy": "Shipping Policy"


}